import React, { useContext, useEffect, useMemo, useState } from 'react'

import { TableContext } from './table/TableContext'
import FormsInProgress from './table/FormsInProgress'
import SubmittedForms from './table/SubmittedForms'
import { SimpleSpinner } from '../../elem/Spinner'
import NewUploadButton from './NewUploadButton'
import { DataContext } from './DataContext'
import BulkSubmitButton from './table/BulkSubmitButton'
import { isReviewerRole } from '../../../utils/user/permissions'
import { UserContext } from '../../wrappers/UserContext'

const SubmissionTabs = ({ onChange, active }) => (
    <>
        <div className="tabs is-large">
            <ul>
                <li
                    className={`${active === 'inProgress' ? 'is-active' : ''}`}
                    onClick={() => onChange('inProgress')}
                >
                    <span className="link">Forms In Progress</span>
                </li>
                <li
                    className={`${active === 'submitted' ? 'is-active' : ''}`}
                    onClick={() => onChange('submitted')}
                >
                    <span className="link">Submitted Forms</span>
                </li>
            </ul>
            <NewUploadButton />
        </div>
    </>
)

export default () => {
    const { loading } = useContext(TableContext)
    const {
        initializeState,
        setActiveAgency,
        setPrimaryKey,
        setErrorState,
    } = useContext(DataContext)
    const { roles } = useContext(UserContext)
    const [activeTab, setActiveTab] = useState('inProgress')
    const isReviewer = useMemo(() => isReviewerRole(roles), [roles])

    useEffect(() => {
        setActiveAgency(null)
        initializeState({})
        setErrorState({})
        setPrimaryKey(null)
    }, [])

    return (
        <div className="container uploads">
            <SubmissionTabs onChange={setActiveTab} active={activeTab} />
            {activeTab === 'inProgress' ? (
                <BulkSubmitButton action="Submit" />
            ) : isReviewer ? (
                <div className="columns m-1">
                    <BulkSubmitButton action="Approve" />
                    <BulkSubmitButton action="Deny" />
                </div>
            ) : null}
            <div className={`section inProgressSection`}>
                {loading ? (
                    <SimpleSpinner />
                ) : activeTab === 'inProgress' ? (
                    <FormsInProgress />
                ) : (
                    <SubmittedForms />
                )}
            </div>
        </div>
    )
}
